import { render, staticRenderFns } from "./reOrderVisitDetail.vue?vue&type=template&id=2ffdf81a&scoped=true"
import script from "./reOrderVisitDetail.vue?vue&type=script&lang=js"
export * from "./reOrderVisitDetail.vue?vue&type=script&lang=js"
import style0 from "./reOrderVisitDetail.vue?vue&type=style&index=0&id=2ffdf81a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffdf81a",
  null
  
)

export default component.exports